import { Component, OnInit, output, inject } from '@angular/core';
import { MatSelectChange, MatSelect } from '@angular/material/select';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ClientIdTextAccountModel } from '../../../../+shared/models/client-id-text-account.model';
import { Client } from '../../../../+shared/models/client';
import { ClientService } from '../../../../+shared/services/client/client.service';
import { UIService } from '../../../../+shared/+state/ui/ui.service';
import { MatOption } from '@angular/material/core';
import { NgClass, AsyncPipe } from '@angular/common';
import { ConvertUTCPipe } from "../../../../+shared/pipes/convert-utc.pipe";
import { Meal } from '../../../../+shared/models/meal'
import { Location } from '../../../../+shared/models/location';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'dish-client-location-select',
    templateUrl: './client-location-select.component.html',
    styleUrls: ['./client-location-select.component.scss'],
    imports: [
    MatSelect,
    MatOption,
    NgClass,
    AsyncPipe,
    ConvertUTCPipe
]
})
export class ClientLocationSelectComponent implements OnInit {
  clientService = inject(ClientService);
  private uiService = inject(UIService);
  private route = inject(ActivatedRoute);

  // Used by mat-select to determine equality between the selected value and options
  compareClientOption = (a: any, b: any) => {
    if (!a || !b) return false;
    const aId = (a as any).id ?? (a as any).clientId;
    const bId = (b as any).id ?? (b as any).clientId;
    return aId === bId;
  };
  readonly clientHasBeenChanged = output<number>();
  allClients$: Observable<ClientIdTextAccountModel[]>;
  currentClient$: Observable<Client>;
  isLocationDisabled$: Observable<boolean>;
  isMealDisabled = true;
  currentSelectedLocation$: Observable<Location> = this.clientService.currentSelectedLocation$;

  selectedLocationMeals$: Observable<Meal[]> = this.currentSelectedLocation$.pipe(
    map((location) => {
      return location.meals;
    })
  );
  readonly selectChange = output();

  ngOnInit(): void {
    this.allClients$ = this.clientService.getAllClients();
    this.currentClient$ = this.clientService.currentClient$;
    this.isLocationDisabled$ = this.currentClient$.pipe(
      map((client) => !client)
    );

    // Auto-select client based on query string clientId, if present
    const qpClientId = this.route.snapshot.queryParamMap.get('clientId');
    if (qpClientId) {
      const idNum = Number(qpClientId);
      if (!isNaN(idNum)) {
        this.clientService.currentClient$.pipe(take(1)).subscribe((curr) => {
          if (!curr || curr.id !== idNum) {
            this.clientService.getById(idNum).pipe(take(1)).subscribe(() => {
              // Reset dependent selections when client changes via query param
              this.uiService.clearCurrentLocationId();
              this.uiService.clearCurrentMealId();
            });
          }
        });
      }
    }
  }

  clientChanged($event: MatSelectChange) {
    this.clientHasBeenChanged.emit($event.value.id);
    this.clientService.getById($event.value.id).pipe(take(1)).subscribe(() => {
    this.uiService.clearCurrentLocationId();
    this.uiService.clearCurrentMealId();
    this.isMealDisabled = true;
    this.selectChange.emit();
    })

  }

  locationChanged($event: MatSelectChange) {
    if (typeof $event.value !== 'number') return;
    this.uiService.setCurrentLocationId($event.value);
    this.uiService.clearCurrentMealId();
    this.isMealDisabled = false;
    this.selectChange.emit();
  }

  mealChanged($event: MatSelectChange) {
    if (typeof $event.value !== 'number') return;
    this.uiService.setCurrentMealId($event.value);
    this.selectChange.emit();
  }
}
